import {Component} from '@angular/core';
import {MerchantService} from '../../../shared/services/merchant/merchant.service';
import {DeviceConfigurationResponseModel} from '../../../shared/services/merchant/deviceConfigurationResponse.model';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss']
})
export class DevicesComponent {
  public deviceConfigurations: DeviceConfigurationResponseModel[] | null | undefined = undefined;
  public currentDevice: DeviceConfigurationResponseModel | null = null;

  constructor(private merchantService: MerchantService) {
    this.merchantService.getDeviceConfigurations().subscribe({
      next: data => {
        this.deviceConfigurations = data;
      },
      error: err => {
        this.deviceConfigurations = null;
        console.log(err);
      },
    });
  }
}
